import { render, staticRenderFns } from "./AuthSidePassword.vue?vue&type=template&id=ecd64f48&scoped=true&"
import script from "./AuthSidePassword.vue?vue&type=script&lang=js&"
export * from "./AuthSidePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd64f48",
  null
  
)

export default component.exports